import React from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { useTranslation } from 'react-i18next';

export default function ListItemI18NRender(props) {
  
  const { t } = useTranslation('news');
  const transval = t(props.ns + props.k);
  const label = !!(props.labelKey)?t(props.labelKey):null;
  const ret = !!(label)? label + ': ' + transval: transval;

  

  return (
    <>
      {(transval===props.k)?null:<ListItem dense={true} sx={{p:0,m:0,pl:2}} ><ListItemText sx={{p:0,m:0}} primary={ret}/></ListItem>} 
    </>
  )
}
